export function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export function isMobileScreen(breakpoint = 820) {
    return window.innerWidth <= breakpoint && isTouchDevice();
}
